
import { IVeriMapChildComponent, IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { IPlot } from "@interfaces/IPlot";
import { GoogleMarkerService } from "@services/googleMarker.service";
import { JourneyService } from "@services/journey.service";
import { MapService } from "@services/map.service";
import { PlotService } from "@services/plot.service";
import { VeriMarkerService } from "@services/veriMarker.service";
import { IMarkerOptions, IPolyline } from "@typings/google.maps.angular";
import * as angular from "angular";
import copy from "fast-copy/dist/fast-copy.esm.js";
import "./veriMapPlotHistory.html";

interface IVeriMapPlotHistoryBindings {

    veriMap: IVeriMapComponent;

    plots: IPlot[];
    polylinePlots: IPlot[];
    hideSimilarPlots: boolean;
    fit: boolean;

    highlightedPlot: IPlot;
    lastHighlightedPlot: IPlot;
    selectedPlot: IPlot;

    onPlotHighlighted: (plot: { $plot: IPlot }) => void;
    onPlotLeave: (plot: { $plot: IPlot }) => void;
    onPlotSelected: (plot: { $plot: IPlot }) => void;
}

class VeriMapPlotHistoryComponentController implements angular.IComponentController, IVeriMapPlotHistoryBindings, IVeriMapChildComponent {
    veriMap: IVeriMapComponent;

    plots: IPlot[];
    polylinePlots: IPlot[];
    displayPlots: IPlot[];
    hideSimilarPlots: boolean;
    fit: boolean;
    highlightedPlot: IPlot;
    lastHighlightedPlot: IPlot;
    selectedPlot: IPlot;

    onPlotHighlighted: (plot: { $plot: IPlot }) => void;
    onPlotLeave: (plot: { $plot: IPlot }) => void;
    onPlotSelected: (plot: { $plot: IPlot }) => void;

    plotPolyline: IPolyline;

    idleListener: google.maps.MapsEventListener;

    markerOptions: IMarkerOptions<IPlot> = {
        events: {
            click: (markerObj: google.maps.Marker, eventName: string, plot: IPlot/*, args: any[]*/) => {
                this.setSelectedPlot(plot);
            },
            mouseover: (markerObj: google.maps.Marker, eventName: string, plot: IPlot/*, args: any[]*/) => {
                if (plot.markerModel?.options.isPip) {
                    this.veriMarkerService.createVeriMarkerOptions(plot);
                    this.googleMarkerService.generateMarkerOptions(plot, plot.veriMarkerOptions).then(options => {
                        plot.markerModel.options = options;
                    });
                }

                this.setHighlightedPlot(plot);
            },
            mouseout: (markerObj: google.maps.Marker, eventName: string, plot: IPlot) => {
                this.setHighlightedPlot(plot, false);
            }
        },
        control: {}
    };

    static $inject = ["plotService", "journeyService", "veriMarkerService", "googleMarkerService", "mapService"];

    constructor(
        private readonly plotService: PlotService,
        private readonly journeyService: JourneyService,
        private readonly veriMarkerService: VeriMarkerService,
        private readonly googleMarkerService: GoogleMarkerService,
        private readonly mapService: MapService) {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {

        if (onChangesObj["plots"]) {

            if (!onChangesObj["polylinePlots"] && this.polylinePlots === undefined) {
                this.polylinePlots = this.plots;
            }

            this.setSelectedPlot(null);
            this.setHighlightedPlot(null);

            if (this.veriMap.getMap()) {
                this.hidePlotsBasedOnZoomLevel();
                this.fitMap();
            }
        }

        if (onChangesObj["selectedPlot"]) {
            if (this.veriMap.getMap()) {
                this.hidePlotsBasedOnZoomLevel();
            }
        }

        if (onChangesObj["plots"] || onChangesObj["polylinePlots"]) {
            this.createPolyline();
        }
    }

    $onInit(): void {
        this.veriMap.mapInitialisedPromise
            .then(map => {
                this.fitMap();

                this.idleListener = this.veriMap.getMap().addListener("idle", () => {
                    this.hidePlotsBasedOnZoomLevel();
                });
            })
            .catch(e => {
                console.error("mapReady error", e);
            });

        this.veriMap.registerChildComponent(this);
    }

    $onDestroy(): void {
        this.veriMap.deregisterChildComponent(this);
        this.idleListener.remove();
    }

    getLatLngsForFitMap(): google.maps.LatLng[] {

        const latLngs: google.maps.LatLng[] = [];

        if (!this.plots) {
            return latLngs;
        }

        this.plots.forEach(plot => {
            latLngs.push(new google.maps.LatLng(plot.Latitude, plot.Longitude));
        });

        return latLngs;
    }

    private setSelectedPlot(plot: IPlot) {
        this.selectedPlot = plot;

        this.setHighlightedPlot(plot);

        if (this.onPlotSelected) {
            this.onPlotSelected({ $plot: plot });
        }
    }

    private setHighlightedPlot(plot: IPlot, highlight: boolean = true) {
        if (highlight) {
            this.highlightedPlot = plot;

            if (this.onPlotHighlighted) {
                this.onPlotHighlighted({ $plot: plot });
            }
        }
        else {
            this.highlightedPlot = this.lastHighlightedPlot;
            this.lastHighlightedPlot = plot;

            if (this.onPlotLeave) {
                this.onPlotLeave({ $plot: plot });
            }
        }
    }

    private hidePlotsBasedOnZoomLevel() {
        //this.displayPlots = this.plots;
        //this.displayPlots = this.plotService.simplifyPlots(this.displayPlots, this.selectedPlot, 0.00001);
        this.plotService.getVisisblePlotsBasedOnZoomLevel(this.displayPlots, this.veriMap.getMap(), this.selectedPlot).then(displayPlots => {
            this.displayPlots = displayPlots;

            if (this.selectedPlot && this.displayPlots) {
                this.displayPlots.forEach((plot, i) => {
                    if (plot.Id === this.selectedPlot.Id) {
                        this.displayPlots[i] = copy(plot);
                    }
                });
            }
        });

        //console.log(this.displayPlots.length, simplifiedPlots.length);

        // COmmented by CJE  27/06/2019 - unsure if needed

    }

    private createPolyline() {
        const journeyEvents = {
            mouseover: (p: google.maps.Polyline, eventName: string, model: any, args: any[]) => {
                var mouseEvent: google.maps.MouseEvent = args[0];
            }
        };

        const latLngArray = this.mapService.convertPlotsToGoogleLatLng(this.polylinePlots);
        this.plotPolyline = this.mapService.createPolyline(1, latLngArray, null, journeyEvents);
    }

    private fitMap() {
        if (!this.fit) {
            return;
        }

        const latLngs = this.getLatLngsForFitMap();

        this.veriMap.fitMap(latLngs);
    }
}

export class VeriMapPlotHistoryComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    require: { [index: string]: string; };

    constructor() {
        this.bindings = {
            plots: "<",
            polylinePlots: "<",
            fit: "<",
            highlightedPlot: "<",
            selectedPlot: "<",

            onPlotHighlighted: "&",
            onPlotSelected: "&",
            onPlotLeave: "&"
        };

        this.require = {
            veriMap: "^veriMap"
        };

        this.controller = VeriMapPlotHistoryComponentController;
        this.template = require("./veriMapPlotHistory.html");
    }
}
